export default "__VITE_ASSET__CljgER1S__ 1920w";